const { Card, CardContent, TableContainer, Paper, Table, TableBody, TableRow, TableCell, Typography } = require("@mui/material");

const Info = ({info}) => { 
  /*return (
    <Card sx={{maxHeight: '100%', display: 'flex', flexDirection: 'column'}}>
          <CardContent sx={{overflow: 'auto'}}>
            <div>Информация об оборудовании</div>
          </CardContent>
    </Card> 
  );*/
  return (
    <TableContainer component={Paper} sx={{maxHeight: '100%', display: 'flex', flexDirection: 'column'}} >
      <Typography align='center' variant='h6' sx={{width: '100%'}}>Информация об оборудовании</Typography>
      <Table>
        <TableBody>
          {info?.map((el) => (
            <TableRow key={el.type} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableCell component="th" scope="row">{el.name}</TableCell>
              <TableCell align="right">{el.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
};

export default Info;